module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1523-352530ad21b1bad2856163858f9f645e.png";